import { useEffect, useState } from "react";
import "./AbsenceList"
import { List } from "@mui/material";
import AbsenceItem from "../absenceItem/AbsenceItem";
import LoadingSpinner from "../../../../../../sharedComponents/LoadingSpinner/LoadingSpinner";

function AbsenceList(props) {

    const [absences, setAbsences] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if(props.absences === null) return;
        setAbsences(props.absences);
        setIsLoading(false);
    }, [props.absences])

    function filterAbsences(data, filters = {}) {
        if(data === null) return;

        return data.filter(absence => {
            return absence.absence_days.some(day => {
                const date = new Date(day.date);
                let matches = true;                
                if (filters.year !== undefined) {
                    matches = matches && date.getFullYear() === filters.year;
                }                
                if (filters.month !== undefined) {
                    matches = matches && date.getMonth() + 1 === filters.month;
                }                
                return matches;
            });
        });
    }

    function createAbsenceItems() {
        let absenceshtml = [];

        // selectedMonth === null bedeutet: ganzes Jahr (kein Monatsfilter)
        const hasMonthFilter = props.selectedMonth !== null && props.selectedMonth !== undefined;
        const yearFilter = hasMonthFilter ? props.selectedMonth.getFullYear() : props.selectedYear;

        const filters = { year: yearFilter };
        if (hasMonthFilter) {
            filters.month = props.selectedMonth.getMonth() + 1;
        }

        const absencesInTimeframe = filterAbsences(absences, filters)
        absencesInTimeframe.sort((a, b) => a.absence_days[0].date.localeCompare(b.absence_days[0].date))

        absencesInTimeframe.forEach((element) => {
            let hourObject;
            let minuteObject;
            if(element.absence_days[0].duration.split('H')[1] === undefined){
                hourObject = 0;
                minuteObject = element.absence_days[0].duration.match(/\d+/);
            } else {
                hourObject = element.absence_days[0].duration.match(/\d+/);
                minuteObject = element.absence_days[0].duration.split('H')[1].match(/\d+/)
            }            
            let length = element.absence_days.length;
            let isTerminatedTime = !element.absence_days[0].ignore_specific_date;

            absenceshtml.push(
                <AbsenceItem
                    key={element.id}
                    listOnClick={() => {props.setOpenRemovingModal(true); props.setSelectedId(element.id)}}  
                    itemButtonOnClick={() => handleAbsenceClick(element.absence_days)}
                    length={length}
                    hourObject={hourObject}
                    minuteObject={minuteObject}
                    isTerminatedTime={isTerminatedTime}
                    absenceType={element.absence_type}
                    paid={element.paid}
                />
            )
        })

        return absenceshtml;
    }

    const handleAbsenceClick = (dateArray) => {
        const dates = dateArray.map(item => {
            const dateObj = new Date(item.date);
            const day = dateObj.getDate().toString().padStart(2, '0');
            const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
            const year = dateObj.getFullYear();
            return `${day}.${month}.${year}`;
        })

        props.setDateArray(dates);
        props.setOpenDetailModal(true);
    }

    return isLoading ?
        <LoadingSpinner/>
        :
        (
            <List className="parent-list-all-months" sx={{width: "50%"}}>
                {createAbsenceItems()}
            </List>
        )
} 

export default AbsenceList;